/**
 * Firebase Service Initialization
 * Configures connection to Firebase Authentication, Firestore DB, and Cloud Storage.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration for Urena Sales Project
const firebaseConfig = {
  apiKey: "AIzaSyDTAeTA5i9RpaOTiYjQeEWoBrgxF81YqV0",
  authDomain: "urena-sales.firebaseapp.com",
  projectId: "urena-sales",
  storageBucket: "urena-sales.firebasestorage.app",
  messagingSenderId: "622299961958",
  appId: "1:622299961958:web:b4800868fddbfbd267eba7",
  measurementId: "G-Q7CXBFY9GC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (err) {
  console.warn("Analytics initialization skipped:", err);
}

// Enable Firestore offline persistence gracefully
try {
  enableIndexedDbPersistence(db).catch((err) => {
    console.warn("Firestore offline persistence failed to enable:", err.code);
  });
} catch (err) {
  console.warn("Firestore offline persistence failed to initialize:", err);
}

export default app;

